/* @flow */

import React from 'react';

import BillPortfolioComponent from 'app/companies/bills';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function ConfirmingBillPortfolioPage() {
  return (
    <WebsitePageComponent id="confirming.bills.title" data-walkme="accountancy-title-documents" noPaper>
      <BillPortfolioComponent />
    </WebsitePageComponent>
  );
}
